import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit"
import { RootState } from "../store"
import BaseApi from "../../api/api"
import { NotificationService } from "../../features/NotificationService/NotificationService"
import { STATUS } from "../../utils/const"
import { RecodeSamsonWbType } from "../../components/Samson/UpdateStocks/wb/recode"
import { RecodeSamsonYaType } from "../../components/Samson/UpdateStocks/ya/recode"

type initialStateType = {
  wildberries: {
    lastStocksUpdated: string
    lastPricesUpdated: string
    status: STATUS
    isExistRecode: boolean
    errors?: { type: string; errors: any[] }[]
  }
  ya: {
    lastStocksUpdated: string
    lastPricesUpdated: string
    status: STATUS
    isExistRecode: boolean
  }
}

const initialState: initialStateType = {
  wildberries: {
    lastStocksUpdated: "",
    lastPricesUpdated: "",
    status: STATUS.SUCCESS,
    isExistRecode: false,
  },
  ya: {
    lastStocksUpdated: "",
    lastPricesUpdated: "",
    status: STATUS.SUCCESS,
    isExistRecode: false,
  },
}

const updateStocksSamsonSlice = createSlice({
  name: "updateStocksSamson",
  initialState,
  reducers: {
    setUpdateStocksSamsonState: (
      state,
      action: PayloadAction<initialStateType>,
    ) => {
      state.wildberries = action.payload.wildberries
      state.ya = action.payload.ya
    },
  },
})

export const selectUpdateStocksSamsonStore = (state: RootState) =>
  state.updateStocksSamson

export default updateStocksSamsonSlice.reducer

export const { setUpdateStocksSamsonState } = updateStocksSamsonSlice.actions

export const updateSamsonState = createAsyncThunk(
  "updateSamsonState",
  (_, { dispatch }) => {
    return BaseApi.samsonState()
      .then((response) => {
        if (response.data) {
          dispatch(setUpdateStocksSamsonState(response.data))
        }
      })
      .catch((error) => {
        console.error(error)
      })
  },
)

export const samsonWbUpdateStocks = createAsyncThunk(
  "samsonUpdateStocks",
  (
    props: {
      selectedStorageId: string
      updatePrices: boolean
      updateStocks: boolean
    },
    { dispatch },
  ) => {
    const { selectedStorageId, updatePrices, updateStocks } = props
    return BaseApi.samsonUpdateStocks(
      selectedStorageId,
      updatePrices,
      updateStocks,
    )
      .then((response) => {
        if (response.data) {
          response.data?.state &&
            dispatch(setUpdateStocksSamsonState(response.data.state))
          NotificationService.showNotification({
            message: response.data.message,
            level: (response.data.success && "success") || "error",
          })
        }
      })
      .catch((error) => {
        error?.response?.data?.state &&
          dispatch(setUpdateStocksSamsonState(error.response.data.state))
      })
  },
)

export const samsonYaUpdateStocks = createAsyncThunk(
  "samsonYaUpdateStocks",
  (
    props: {
      selectedStorageId: string
      updatePrices: boolean
      updateStocks: boolean
    },
    { dispatch },
  ) => {
    const { selectedStorageId, updatePrices, updateStocks } = props
    return BaseApi.samsonYaUpdateStocks(
      selectedStorageId,
      updatePrices,
      updateStocks,
    )
      .then((response) => {
        if (response.data) {
          response.data?.state &&
            dispatch(setUpdateStocksSamsonState(response.data.state))
          NotificationService.showNotification({
            message: response.data.message,
            level: (response.data.success && "success") || "error",
          })
        }
      })
      .catch((error) => {
        error?.response?.data?.state &&
          dispatch(setUpdateStocksSamsonState(error.response.data.state))
      })
  },
)

export const deleteSamsonWbRecode = createAsyncThunk(
  "deleteSamsonRecode",
  (_, { dispatch }) => {
    return BaseApi.deleteRecodeSamson()
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStocksSamsonState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStocksSamsonState(error.response.data.state))
      })
  },
)

export const uploadSamsonWbRecode = createAsyncThunk(
  "uploadSamsonRecode",
  async (rows: RecodeSamsonWbType[], { dispatch }) => {
    return BaseApi.uploadRecodeSamson(rows)
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStocksSamsonState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStocksSamsonState(error.response.data.state))
      })
  },
)

export const deleteSamsonYaRecode = createAsyncThunk(
  "deleteSamsonYaRecode",
  (_, { dispatch }) => {
    return BaseApi.deleteRecodeYaSamson()
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStocksSamsonState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStocksSamsonState(error.response.data.state))
      })
  },
)

export const uploadSamsonYaRecode = createAsyncThunk(
  "uploadSamsonYaRecode",
  async (rows: RecodeSamsonYaType[], { dispatch }) => {
    return BaseApi.uploadRecodeYaSamson(rows)
      .then((response) => {
        response.data?.state &&
          dispatch(setUpdateStocksSamsonState(response.data.state))
        NotificationService.showNotification({
          message: response.data.message,
          level: (response.data.success && "success") || "error",
        })
      })
      .catch((error) => {
        console.error(error)
        error?.response?.data?.state &&
          dispatch(setUpdateStocksSamsonState(error.response.data.state))
      })
  },
)
